
/*
 * VNCmail : A whole new experience in enterprise email communication.
 * Copyright (C) 2015-2020 VNC – Virtual Network Consult AG (info@vnc.biz)
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, version 3 of the License.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. Look for COPYING file in the top folder.
 * If not, see http://www.gnu.org/licenses/.
 */

import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";

setupTheme();

if (environment.production || environment.isCordova || environment.isElectron) {
/*  enableProdMode();
  window.console.log = function () {
  };
  window.console.debug = function () {
  }; */
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));

function loadExternalStyle(styleUrl: string) {
  return new Promise((resolve, reject) => {
    let styleElement = document.createElement("link");
    styleElement.rel = "stylesheet";
    styleElement.type = "text/css";
    styleElement.href = styleUrl;
    styleElement.onload = function () {
      resolve(true);
    };
    document.head.appendChild(styleElement);
    styleElement = null;
  });
}

function loadExternalScript(scriptUrl: string) {
  return new Promise(resolve => {
    let scriptElement = document.createElement("script");
    scriptElement.src = scriptUrl;
    scriptElement.onload = resolve;
    document.body.appendChild(scriptElement);
    scriptElement = null;
  });
}

function showApp() {
  console.log("[setupTheme] loaded theme and display the app", new Date());
  document.querySelector("vp-app").removeAttribute("style");
}

function setupTheme() {
  const HASH_VALUE = "4d219884e4ae8d701fa24998d842f2957642ea6b";
  console.log("[setupTheme]", new Date(), environment);
  document.querySelector("vp-app").setAttribute("style", "display: none");
  if (environment.isCordova) {
    loadExternalScript("cordova.js");
    loadExternalStyle("assets/css/smooth-scroll.css");
  }
  const currentName = localStorage.getItem("theme") || environment.theme;
  const themePath = `${HASH_VALUE}.`;
  if (currentName === "dfb") {
    loadExternalStyle(themePath + "dfb.css").then(() => { console.log("[setupTheme] loaded theme dfb", new Date()); showApp(); }).catch(() => { showApp(); });
  } else if (currentName === "dfb_blue") {
    loadExternalStyle(themePath + "dfb_blue.css").then(() => { console.log("[setupTheme] loaded theme dfb blue", new Date()); showApp(); }).catch(() => { showApp(); });
  } else {
    loadExternalStyle(themePath + "vncmail.css").then(() => { console.log("[setupTheme] loaded theme vncmail", new Date()); showApp(); }).catch(() => { showApp(); });
  }
  document.title = environment.title;
}
